import { types } from 'mobx-state-tree'

export const editableModel = () =>
  types.model().actions((self) => ({
    setValue: (k: string, value: any) => ((self as any)[k] = value),
  }))
